var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 18.4H7.52344C7.1194 18.4 6.7319 18.2483 6.4462 17.9782C6.1605 17.7082 6 17.3419 6 16.96V5.44C6 5.05809 6.1605 4.69182 6.4462 4.42177C6.7319 4.15171 7.1194 4 7.52344 4H13.8555L18.1875 8.04V11.5M13.5 4V8.8H18.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2327 14.2222C16.1459 13.9712 15.9873 13.7524 15.7773 13.594C15.5673 13.4356 15.3156 13.3448 15.0545 13.3333H13.3091C12.9619 13.3333 12.6289 13.4738 12.3834 13.7239C12.1379 13.9739 12 14.313 12 14.6667C12 15.0203 12.1379 15.3594 12.3834 15.6095C12.6289 15.8595 12.9619 16 13.3091 16H15.0545C15.4017 16 15.7347 16.1405 15.9802 16.3905C16.2257 16.6406 16.3636 16.9797 16.3636 17.3333C16.3636 17.687 16.2257 18.0261 15.9802 18.2761C15.7347 18.5262 15.4017 18.6667 15.0545 18.6667H13.3091C13.048 18.6552 12.7963 18.5644 12.5864 18.406C12.3764 18.2476 12.2178 18.0288 12.1309 17.7778M14.1818 12V13.3333M14.1818 18.6667V20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionMenuIcon);
export default __webpack_public_path__ + "static/media/subscription-menu-icon.9dc6987dc48ba160b495f05e80238181.svg";
export { ForwardRef as ReactComponent };